import { render } from "./AddTaskDialog.vue?vue&type=template&id=1b13e0c0&scoped=true"
import script from "./AddTaskDialog.vue?vue&type=script&lang=js"
export * from "./AddTaskDialog.vue?vue&type=script&lang=js"

import "./AddTaskDialog.vue?vue&type=style&index=0&id=1b13e0c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b13e0c0"]])

export default __exports__